import React from 'react';
import useCars from 'app/hook/cars/useCars';
import LayerViewer from 'app/components/common/LayerViewer';
import classNames from 'classnames/bind';

import styles from './LayerChoiceOption.module.scss';

const cx = classNames.bind(styles);

function LayerChoiceOption({ handleLayerClose }) {
	const { sellingpoint, optionChoice } = useCars();

	const photos = sellingpoint.choiceOptionPhotos?.filter((n) => n.attachment) || [];

	const photosPrice = photos.map((data) => {
		const choiceCode = optionChoice.find((item) => item.optionCd === data.partCode.split('_')[1]);
		return {
			...data,
			price: choiceCode?.price || 0,
		};
	});

	const dataElement = photosPrice.map((item) => (
		<li key={item.autoPartId}>
			<img
				src={`${item.attachment.url[0].replace('http://imgcar', 'https://imgcar')}?d=640x360`}
				className={cx('thumb')}
				alt=""
			/>
			<p className={cx('desc')}>
				{item.partName}
				<span className={cx('price')}>{item.price}만원</span>
			</p>
		</li>
	));
	return (
		<LayerViewer
			title="선택 옵션 사진 자세히 보기"
			onClose={handleLayerClose}
		>
			<ul className={cx('list_photo')}>{dataElement}</ul>
		</LayerViewer>
	);
}

export default LayerChoiceOption;
